import {useContext} from 'react'
import { Link, useParams } from "react-router-dom";
import Header from "../../components/Header";
import {LocaleParams} from "../../types"
import {Product} from '@cocunat/ui-components'
import { MainContext } from '../../context/main';

function Cart() {
    const { lang, country } = useParams<LocaleParams>();
    const {products} = useContext(MainContext);
    return (
        <div>
            <Header />
            <div className='container'>
                <h1>CART</h1>
                <Link to={`/${lang}-${country}/gallery/`}>
                    <button>Go to Gallery</button>
                </Link>
                <div className='row'>

                    
                </div>
            </div>
        </div>
    );
}

export default Cart;
